<template>
    <div style="width:100%"> 
        <el-input placeholder="请输入内容" v-model="value" :size="size">              
            <el-button slot="append" icon="el-icon-search" @click="onHanhleClick"></el-button>           
        </el-input>   
        <InventoryQWindow ref="window"  :windowToBody=toBody :show=showWindow @onClose="onCloseWindow" @onSelectedInventory="onSelected"></InventoryQWindow> 
    </div>  
</template>

<script>
import InventoryQWindow from 'busicomponent/window/InventoryQWindow.vue'
export default {
    components:{
        InventoryQWindow
    },
    props:{
        size:String,
        value:String,
        visiblWindow:{
           Type:Boolean,
           default(){
               return false;
           }
        },
        windowToBody:{
           Type:Boolean,
           default(){
               return false;
           }
        }
    },
    model:{
        prop:'value',
        event:'input'
    },
    watch:{
        value:function(newVal,oldVal){
            this.$emit('input',newVal)
        },
        visiblWindow:function(newVal,oldVal){
            this.showWindow=newVal;
        },
        windowToBody(newVal,oldVal){
           this.toBody=newVal;
        }
    },
    data(){
        return {
            showWindow:this.visiblWindow,
            toBody:this.windowToBody
        }
    },    
    methods:{
        onHanhleClick(){
           this.showWindow=true;
        },
        onCloseWindow(value){
          this.showWindow=value;  
        },
        onSelected(companyRow){   
            // debugger;        
           if(companyRow){   
               this.$emit("onEyeChange",companyRow)
               this.showWindow=false;
           }
        }
    }
}
</script>